import React, { useMemo } from "react";
import Layout from "../components/Layout";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import "./Research.css";

export default function Research() {
  const brandColor = "#002244";
  const { i18n } = useTranslation();
  const lang = (i18n?.language || "az").toLowerCase();

  // ✅ Data artıq component-in içindədir (3 dil)
  const research = useMemo(
    () => [
      {
        year: "2025",
        tag: { az: "Məqalə", en: "Article", ru: "Статья" },
        title: {
          az: "Peptid fraksiyalarının analizi",
          en: "Peptide Fraction Analysis",
          ru: "Анализ пептидных фракций",
        },
        desc: {
          az: "HPLC və MS analizləri üzrə xülasə.",
          en: "Summary of HPLC and MS analyses.",
          ru: "Краткое описание анализов HPLC и MS.",
        },
      },
      {
        year: "2025",
        tag: { az: "Protokol", en: "Protocol", ru: "Протокол" },
        title: {
          az: "Stabillik və saxlanma protokolu",
          en: "Stability & Storage Protocol",
          ru: "Протокол стабильности и хранения",
        },
        desc: {
          az: "Nəmlik təsirlərinin qiymətləndirilməsi.",
          en: "Assessment of humidity impact.",
          ru: "Оценка влияния влажности.",
        },
      },
      {
        year: "2024",
        tag: { az: "Lab nəticə", en: "Lab result", ru: "Результаты" },
        title: {
          az: "Batch QC nəticələri",
          en: "Batch QC Results",
          ru: "Результаты QC партии",
        },
        desc: {
          az: "Endotoksin və profil uyğunluğu.",
          en: "Endotoxin and profile compliance.",
          ru: "Соответствие эндотоксина и профиля.",
        },
      },
      {
        year: "2024",
        tag: { az: "Lab nəticə", en: "Lab result", ru: "Результаты" },
        title: {
          az: "Batch QC nəticələri",
          en: "Batch QC Results",
          ru: "Результаты QC партии",
        },
        desc: {
          az: "Endotoksin və profil uyğunluğu.",
          en: "Endotoxin and profile compliance.",
          ru: "Соответствие эндотоксина и профиля.",
        },
      },
    ],
    []
  );

  const L = lang.startsWith("en") ? "en" : lang.startsWith("ru") ? "ru" : "az";
  const tr = (obj) => (obj?.[L] ?? obj?.az ?? "");

  // ✅ Səhifə textləri də component içində (i18n key yazmadan)
  const pageTitle =
    L === "en" ? "Research" : L === "ru" ? "Исследования" : "Tədqiqat";
  const pageSub =
    L === "en"
      ? "Scientific articles, lab results, and technology overview."
      : L === "ru"
      ? "Научные статьи, результаты лаборатории и обзор технологий."
      : "Elmi məqalələr, laboratoriya nəticələri və texnologiya xülasəsi.";

  const yearLabel = L === "en" ? "Year:" : L === "ru" ? "Год:" : "İl:";
  const collabBtn =
    L === "en" ? "Collaboration" : L === "ru" ? "Сотрудничество" : "Əməkdaşlıq";
  const newsBtn = L === "en" ? "News" : L === "ru" ? "Новости" : "Xəbərlər";

  const techTitle =
    L === "en" ? "Technology" : L === "ru" ? "Технология" : "Texnologiya";
  const processHint =
    L === "en" ? "Process stages" : L === "ru" ? "Этапы процесса" : "Proses mərhələləri";

  const steps = [
    {
      i: "📦",
      t: L === "en" ? "Collection" : L === "ru" ? "Сбор" : "Toplanma",
      d:
        L === "en"
          ? "Sample collection and registration using a standard protocol."
          : L === "ru"
          ? "Сбор и регистрация образцов по стандартному протоколу."
          : "Nümunələrin standart protokolla toplanması və qeydiyyatı.",
    },
    {
      i: "🧊",
      t: L === "en" ? "Stabilization" : L === "ru" ? "Стабилизация" : "Stabilizasiya",
      d:
        L === "en"
          ? "Initial processing to ensure stability of active components."
          : L === "ru"
          ? "Первичная обработка для стабильности активных компонентов."
          : "Aktiv komponentlərin stabilliyi üçün ilkin emal mərhələsi.",
    },
    {
      i: "❄️",
      t: L === "en" ? "Lyophilization" : L === "ru" ? "Лиофилизация" : "Lyophilization",
      d:
        L === "en"
          ? "Freeze-drying process for storage and preservation."
          : L === "ru"
          ? "Процесс лиофилизации для хранения и сохранности."
          : "Qurutma və saxlanma üçün lyofilizasiya prosesi.",
    },
    {
      i: "🧪",
      t: "QC",
      d:
        L === "en"
          ? "Parameter checks: moisture, profile, compliance, etc."
          : L === "ru"
          ? "Проверка параметров: влажность, профиль, соответствие и т.д."
          : "Parametrlərin yoxlanması: nəmlik, profil, uyğunluq və s.",
    },
    {
      i: "📄",
      t: L === "en" ? "COA / Certificate" : L === "ru" ? "COA / Сертификат" : "COA / Sertifikat",
      d:
        L === "en"
          ? "Batch documentation and traceability assurance."
          : L === "ru"
          ? "Документирование партии и обеспечение прослеживаемости."
          : "Partiya üzrə sənədləşmə və izlənəbilənlik təminatı.",
    },
    {
      i: "🚚",
      t: L === "en" ? "Delivery" : L === "ru" ? "Доставка" : "Çatdırılma",
      d:
        L === "en"
          ? "Secure packaging and cold-chain logistics."
          : L === "ru"
          ? "Безопасная упаковка и логистика холодовой цепи."
          : "Təhlükəsiz qablaşdırma və soyuq zəncir logistika.",
    },
  ];

  const techNote =
    L === "en"
      ? "This flow is standardized and managed with batch traceability."
      : L === "ru"
      ? "Этот процесс стандартизирован и управляется с прослеживаемостью партий."
      : "Bu axın standartlaşdırılıb və batch izlənəbilənliyi ilə idarə olunur.";

  return (
    <Layout>
      <section className="py-5 researchPage" style={{ ["--brand"]: brandColor }}>
        <div className="container">
          <div className="sectionHead mb-4">
            <h1 className="hTitle mb-1">{pageTitle}</h1>
            <p className="pMuted mb-0">{pageSub}</p>
          </div>

          {/* Cards */}
          <div className="row g-3">
            {research.map((r, idx) => (
              <div key={idx} className="col-12 col-sm-6 col-lg-3">
                <div className="rCard h-100 d-flex flex-column">
                  <div className="d-flex align-items-start justify-content-between gap-2">
                    <div className="rTitle">{tr(r.title)}</div>
                    <span className="rTag">{tr(r.tag)}</span>
                  </div>

                  <div className="rDesc">{tr(r.desc)}</div>


                  <div className="rActions mt-auto">
                    <Link to="/elaqe" className="btn btnBrand w-100">
                      {collabBtn}
                    </Link>

                  </div>
                </div>
              </div>
            ))}
          </div>

          {/* Technology / Process Cards */}
          <div className="rTechCard mt-4">
            <div className="d-flex align-items-end justify-content-between gap-2 mb-3">
              <h3 className="rTechTitle mb-0">{techTitle}</h3>
              <span className="rTechHint">{processHint}</span>
            </div>

            <div className="row g-3">
              {steps.map((s, idx) => (
                <div key={idx} className="col-12 col-sm-6 col-lg-4">
                  <div className="rProcessCard h-100">
                    <div className="rProcessTop">
                      <div className="rProcessIcon" aria-hidden="true">
                        {s.i}
                      </div>
                      <div className="rProcessNum">{String(idx + 1).padStart(2, "0")}</div>
                    </div>

                    <div className="rProcessTitle">{s.t}</div>
                    <div className="rProcessDesc">{s.d}</div>
                  </div>
                </div>
              ))}
            </div>

            <div className="rTechNote">{techNote}</div>
          </div>
        </div>
      </section>
    </Layout>
  );
}
